import { AUTH_MODE } from '@src/components/Checkout/constants';
import type { Order } from '@src/features/orders';
import type { SaleChange } from '@src/features/sales';
import type { Sale } from '@src/core/buyerApiClient';

import type { CheckoutMode } from '../types';
import { decideCheckoutMode, decideCheckoutModeAfterAuth } from '../utils';

type ResolveCheckoutEntryModeParams = {
  initialMode: CheckoutMode;
  logged: boolean;
  skipConfirmation: boolean;
  order?: Order | null;
  sale?: Sale | null;
  saleChange?: SaleChange | null;
  pendingFormInputs?: boolean;
};

export const resolveCheckoutEntryMode = (params: ResolveCheckoutEntryModeParams): CheckoutMode => {
  const { initialMode, logged, skipConfirmation, ...purchase } = params;

  const fromPurchase = decideCheckoutMode(purchase);

  if (fromPurchase) {
    return fromPurchase.mode;
  }

  if (initialMode !== AUTH_MODE || !logged) {
    return initialMode;
  }

  return decideCheckoutModeAfterAuth({ ...purchase, skipConfirmation }).mode;
};
